import apiClient from "@/services/axios";

/**
 * Scolarité and activity fees still owed for the school years preceding the
 * active one, grouped by year.
 *
 * Pass either a parent (all of their children) or an explicit student list.
 * Returns null when there is nothing to ask for or the call fails: a missing
 * carry-over notice must never block the payment screens.
 */
export async function fetchPastYearsArrears({ parentId, studentIds } = {}) {
  const students = studentIds || [];
  if (!parentId && !students.length) return null;

  try {
    const { data } = await apiClient.post(
      "/paymentStatus/past-years-arrears",
      parentId ? { parentId } : { studentIds: students }
    );
    return data;
  } catch (error) {
    return null;
  }
}

export default fetchPastYearsArrears;
